import { Seller } from "../../objects/amazon/seller";

export class NavigateHelper{
    public static amazonSellerRouting(seller: Seller): string{
        if (seller.Stores && seller.Stores.length > 0) {
            const store = seller.Stores[0];
            return `amazon/info/${seller.Id}/store/${store.Id}/products`;
        } else {
            return 'amazon/info/store';
        }
    }
}


// WEBPACK FOOTER //
// ./app/common/helpers/navigateHelper.ts